import React from 'react';
import type { DivisionStandings as DivisionStandingsType } from '@sulis-liiga/common';
import StandingsTable from './StandingsTable';

interface DivisionStandingsProps {
  standings: DivisionStandingsType;
}

/**
 * DivisionStandings component
 *
 * Wraps the StandingsTable with division-specific header information
 * including category, level, and navigation.
 */
const DivisionStandings: React.FC<DivisionStandingsProps> = ({ standings }) => {
  return (
    <div className="bg-white shadow rounded-lg overflow-hidden">
      {/* Division header */}
      <div className="px-6 py-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">{standings.divisionName}</h2>
            <p className="text-sm text-gray-500 mt-1">
              {standings.category} &bull; Level {standings.level}
            </p>
          </div>
          <div className="text-right text-sm text-gray-500">
            <span>{standings.standings.length} team(s)</span>
          </div>
        </div>
      </div>

      {/* Standings table */}
      <div className="px-0 py-4">
        <StandingsTable
          standings={standings.standings}
          teamsToPromote={standings.teamsToPromote}
          teamsToRelegate={standings.teamsToRelegate}
        />
      </div>
    </div>
  );
};

export default DivisionStandings;
